import { render, staticRenderFns } from "./ChargeDetails.vue?vue&type=template&id=4d5bfbab&scoped=true&"
import script from "./ChargeDetails.vue?vue&type=script&lang=js&"
export * from "./ChargeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bfbab",
  null
  
)

export default component.exports